import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppRmaApi } from './app'
import { BackofficeRmaApi } from './backoffice'
import { Queue } from '../../queue'

export class Rma implements ApiNamespaces {
  app: AppRmaApi
  backoffice: BackofficeRmaApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppRmaApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeRmaApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
